'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-86/node_modules/@eliadmin/core/src/components/homepage/homepage-reviews-swiper.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-86/node_modules/@eliadmin/core/src/components/homepage/homepage-reviews-swiper.tsx").HomepageReviewsSwiper>>;
const Deferred = lazy(() => import("@eliadmin/module-original/reviewsSlider").then(m => ({ default: m.HomepageReviewsSwiper })));
export function HomepageReviewsSwiper(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

